import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/client/SkeletonComponent";

const SkeletonExperienceSubmitButtonComponent: FC = () => {
  return <Skeleton className="hidden h-16 w-40 flex-none md:block" />;
};

export default SkeletonExperienceSubmitButtonComponent;
